import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { Sidebar } from "./components/sidebar/sidebar";
import Login from "./components/auth/login";
import PrivateRoute from "./validations/PrivateRoutes";
import { Homepage } from "./pages/homepage";
import { useEffect } from "react";
import { ApplicationDetail } from "./pages/applicationdetail";
import { Evaluation } from "./pages/Evaluation";
import { useSelector } from "react-redux";
import { selectUser } from "./state/features/userSlice";
import { Certificate } from "./pages/Certificate";
import { Report } from "./pages/report";

function App() {
  const currentPath = window.location.pathname.split("/")[1];
  let renderSidebar = false;

  // Conditionally render Sidebar component based on the path
  renderSidebar = currentPath !== "signin";
  return (
    <div className="bg-general_bg m-0 w-full h-screen">
      <BrowserRouter>
        <div className="flex h-full bg-general_bg">
          {renderSidebar && <Sidebar />}
          <div className=" w-full overflow-y-auto no-scrollbar">
            <Routes>
              <Route
                path="/"
                element={<PrivateRoute element={<Homepage />} />}
              />
              <Route path="/signin" element={<Login />} />
              <Route
                path="/application/:name"
                element={<PrivateRoute element={<ApplicationDetail />} />}
              />

              {/* <Route
                path="/closedapplication/:name"
                element={<PrivateRoute element={<ApplicationDetail />} />}
              /> */}
              <Route
                path="/evaluate/:app/:user/:step/:stepid"
                element={<PrivateRoute element={<Evaluation />} />}
              />
              <Route
                path="/certificate/:uac/:user"
                element={<PrivateRoute element={<Certificate />} />}
              />
              <Route path="/report" element={<Report />} />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;

const NotFound = () => {
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  useEffect(() => {
    setTimeout(() => {
      navigate("/");
      window.location.reload();
    }, 1000);
  }, [user]);
  return (
    <div className="flex flex-col gap-0 w-full align-center justify-center">
      <div className="mt-0 text-center">
        <h3 className=" text-6xl font-bold ">404</h3>
        <p className=" text-xl">Page not found!</p>
      </div>
    </div>
  );
};
